export const sharedDocuments = [
  {
    caption: 'Doc alteração',
    value: '01',
  },
  {
    caption: 'Comprovativo da titularidade da conta bancária',
    value: '02',
  },
  {
    caption: 'Folhas de férias e listagens AP Coletivo',
    value: '03',
  },
  {
    caption: 'Doc Proposta',
    value: '04',
  },
  {
    caption: 'Doc Anulação',
    value: '05',
  },
  {
    caption: 'Carta de desinteresse do terceiro interessado',
    value: '06',
  },
  {
    caption: 'Outros Documentos',
    value: '07',
  },
  {
    caption: 'Doc Identificativo (ex. Cartão de Cidadão)',
    value: '08',
  },
  {
    caption: 'DUA',
    value: '09',
  },
]

export const documentOptionsUpload = [
  ...sharedDocuments,
  {
    caption: 'Proposta',
    value: '739',
  },
]
